export default function formatFloorData(floor: any): string | null {
    const num = Number(floor);

    if (floor == null || isNaN(num)) {
        return null;
    }

    if (num === 0) {
        return "Ground Floor";
    }

    return `${num}${getOrdinalSuffix(num)} Floor`;
}

function getOrdinalSuffix(n: number): string {
    const v = n % 100;

    if (v >= 11 && v <= 13) return 'th';

    switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
    }
}